import { render } from "./ReleasePurchaseInfo.vue?vue&type=template&id=7a3eee64&scoped=true"
import script from "./ReleasePurchaseInfo.vue?vue&type=script&lang=js"
export * from "./ReleasePurchaseInfo.vue?vue&type=script&lang=js"

import "./ReleasePurchaseInfo.vue?vue&type=style&index=0&id=7a3eee64&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3eee64"]])

export default __exports__